export { LayerInfoBox } from './LayerInfoBox';